var styleDataHash = '3cb0d923';  
export const injectCss = (() => {
  var css = `.QT08n{align-items:center;display:flex;width:max-content}[dir] .QT08n{background-color:#fff;border:1px solid #ededed;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1))}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "floatingToolbar": "QT08n"
};